import React, { useEffect, useState } from 'react'

import {
  Box,
  Color,
  Display,
  DisplayPosition,
  Icon,
  JustifyContent,
  Overflow,
  ZIndex,
} from '@gousto-internal/citrus-react'

import { useNumPortions } from 'hooks/basket/useNumPortions'
import { useBoxes } from 'hooks/menu-boxes/useBoxes'
import { useMaxRecipesForPortion } from 'hooks/menu-boxes/useMaxRecipesForPortion'

import { RecipesInBasketProgressContent } from './RecipesInBasketProgressContent'

type RecipesInBasketProgressPresentationProps = {
  selectedRecipesCount: number
  onClose: (maxRecipes: number, percentage: number) => void
}

const RecipesInBasketProgressPresentation = ({
  selectedRecipesCount,
  onClose,
}: RecipesInBasketProgressPresentationProps) => {
  const { isBoxesLoading } = useBoxes()
  const { numPortions } = useNumPortions()
  const maxRecipesNum = useMaxRecipesForPortion(numPortions)
  const [isDismissed, setIsDismissed] = useState(false)

  const percentage = Math.round((selectedRecipesCount / maxRecipesNum) * 100)

  useEffect(() => {
    if (!selectedRecipesCount) {
      setIsDismissed(false)
    }
  }, [selectedRecipesCount])

  if (!selectedRecipesCount || isBoxesLoading || isDismissed) {
    return null
  }

  return (
    <Box
      bg={Color.White}
      borderRadius={1.5}
      boxShadow="0 8px 24px rgba(33, 41, 48, 0.16), 0 2px 8px rgba(33, 41, 48, 0.08)"
      position={DisplayPosition.Fixed}
      bottom="8rem"
      left="24px"
      width={['calc(100vw - 48px)', '22rem']}
      maxWidth="22rem"
      overflowY={Overflow.Hidden}
      overflowX={Overflow.Hidden}
      zIndex={ZIndex.Top}
    >
      <Box
        display={[Display.Flex, Display.None]}
        justifyContent={JustifyContent.FlexEnd}
        position={DisplayPosition.Absolute}
        top="4px"
        right="4px"
        zIndex={ZIndex.Top}
      >
        <button
          aria-label="Dismiss recipes in basket progress"
          type="button"
          onClick={() => {
            setIsDismissed(true)
            onClose(maxRecipesNum, percentage)
          }}
          style={{
            appearance: 'none',
            background: 'transparent',
            border: 0,
            borderRadius: '999px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '28px',
            height: '28px',
            padding: 0,
          }}
        >
          <Icon name="close" size={4} color={Color.ColdGrey_500} />
        </button>
      </Box>
      <Box paddingH={2} paddingV={2}>
        <RecipesInBasketProgressContent
          selectedRecipesCount={selectedRecipesCount}
          percentage={percentage}
        />
      </Box>
    </Box>
  )
}

export { RecipesInBasketProgressPresentation }
